import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class NavigationService {
  private lastUrl: string = '/';

  constructor(private router: Router) {
    this.lastUrl = localStorage.getItem('returnUrl') || '/';

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        let url = event.urlAfterRedirects;
        if(!url.includes('/login')) {
          console.log('NavigationService: Updating lastUrl to', url);
          this.lastUrl = event.urlAfterRedirects;
          localStorage.setItem('returnUrl', this.lastUrl);
        }
    });
  }

  getLastUrl(): string {
    return this.lastUrl;
  }
}
